export class MechanicModel {
  mechanicId: number = 0;
  branchId: number = 0;
  typeDocumentId: number = 0;
  document: string = "";
  digitVerification: number = 0;
  name: string = "";
  address: string | null = null;
  phone: string | null = null;
  alterPhone: string | null = null;
  contact: string | null = null;
  swExternal: boolean = false;
  active: boolean = true;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
